import css from './styles/client-menu-item.scss';
import React, { useRef, useState, useEffect } from 'react';
import { Tooltip } from 'shamrock-clover-ui/dist/clover/components/Tooltip/Tooltip';
import { ClientSuggestion } from '../../interfaces/clients';
import RemoveButton from './remove-button';

type ItemProps = {
  isNew?: boolean;
  isBeingRemoved?: boolean;
  client: ClientSuggestion;
  removeButtonAction: Function
};

const ClientMenuItem: React.FC<ItemProps> = ({isNew = false, client, isBeingRemoved, removeButtonAction}) => {
  const clientNumberRef = useRef<HTMLParagraphElement>(null);
  const clientNameRef = useRef<HTMLParagraphElement>(null);
  const clientMCNumberRef = useRef<HTMLParagraphElement>(null);

  const [showTooltip, setShowTooltip] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (clientNumberRef.current && clientNameRef.current) {
      setShowTooltip(
        clientNumberRef.current.offsetWidth < clientNumberRef.current.scrollWidth ||
        clientNameRef.current.offsetWidth < clientNameRef.current.scrollWidth ||
        clientMCNumberRef.current.offsetWidth < clientMCNumberRef.current.scrollWidth,
      );
    }
  }, [clientNumberRef]);

  const removalStyle={
    textDecoration: 'line-through',
    color: '#666666',
  };

  const clientItem = (
    <div className={css.outerClientItemDiv} style={{ background: isHovered ? '#EEEEEE' : '#FFFFFF' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      <div className={css.innerClientItemDiv}
        style={isBeingRemoved ? removalStyle : {}}>
        {isNew ? <div className={css.newItemDot} data-testid='newItemDot' /> : <div className={css.newItemSpacer} />}
        <div className={css.clientNumberDiv} ref={clientNumberRef}>{client.client_number}</div>
        <div className={css.clientNameDiv} ref={clientNameRef}>{client.client_name}</div>
        <div className={css.clientMCNumberDiv} ref={clientMCNumberRef}>{client.mc_number}</div>
        <div className={css.removeButtonDiv} data-testid='removeButton'>
          <RemoveButton isBeingRemoved={isBeingRemoved} removeButtonAction={removeButtonAction} client={client}/>
        </div>
      </div>
    </div>
  );

  if (!showTooltip) {
    return clientItem;
  }

  const tooltipTitle = client.mc_number ?
    `${client.client_number} - ${client.client_name} - (${client.mc_number})` :
    `${client.client_number} - ${client.client_name}`;

  return (
    <Tooltip style={{ zIndex: 10000 }} title={tooltipTitle} key={client.client_number}>
      {clientItem}
    </Tooltip>
  );
};

export default ClientMenuItem;
